<template>
  <div class="col-md-12">
    <Form ref="profileForm" :validation-schema="schema" @submit="handleUpdate" @invalid-submit="handleInvalidSubmit">
      <div>
        <DashboardHeader :firstname=firstname :profile-picture-url=profilePictureUrl :title=title :subtitle='subtitle' :editable=true @update-photo="handlePhotoUpdate"/>
        <div class="register-obligatoire">
          * champs obligatoires
        </div>
        <div class="header-group">
          <h1><img src="@/assets/img/underline.png"> MON PROFIL</h1>
        </div>
        <div class="form-group">
          <Field v-model="civility" as="select" class="form-control" name="civility" placeholder="Civilité*">
            <option disabled value="">Civilité*</option>
            <option value="Monsieur">Monsieur</option>
            <option value="Madame">Madame</option>
          </Field>
          <ErrorMessage class="error-feedback" name="civility"/>
        </div>
        <div class="form-group">
          <Field v-model="lastname" class="form-control" name="lastname" placeholder="Nom de naissance*" type="text"/>
          <ErrorMessage class="error-feedback" name="lastname"/>
        </div>
        <div v-if="civility == 'Madame'" class="form-group">
          <Field v-model="marriedname" class="form-control" name="marriedname" placeholder="Nom marital" type="text"/>
          <ErrorMessage class="error-feedback" name="marriedname"/>
        </div>
        <div class="form-group">
          <Field v-model="firstname" class="form-control" name="firstname" placeholder="Prénom*" type="text"/>
          <ErrorMessage class="error-feedback" name="firstname"/>
        </div>
        <div class="form-group">
          <Field v-model="birthday" class="form-control" name="birthday" placeholder="Date de naissance*" type="date"/>
          <ErrorMessage class="error-feedback" name="birthday"/>
        </div>
        <div class="form-group">
          <Field v-model="nationality" as="select" class="form-control" name="nationality">
            <option disabled value="">Nationalité*</option>
            <option
                v-for="nat in nationalities"
                :key="nat.id"
                :value="String(nat.id)"
            >
              {{ nat.label }}
            </option>
          </Field>
          <ErrorMessage class="error-feedback" name="nationality"/>
        </div>
        <div class="form-group custom-control custom-checkbox">
          <input id="bornAbroad" v-model="bornAbroad" class="custom-control-input checkbox-lg" type="checkbox">
          <label class="custom-control-label" for="bornAbroad">Né(e) à l'étranger</label>
        </div>
        <div v-if="!bornAbroad" class="form-group">
          <vue3-simple-typeahead
              id="birthplaceList"
              ref="birthplaceList"
              v-model="birthCitySearch"
              :defaultItem="birthplaceCity"
              :itemProjection="birthCityItemProjection"
              :items="birthCityList"
              :minInputLength="3"
              name="birthplaceList"
              placeholder="Ville de naissance*"
              @input="onBirthCityInput"
              @onBlur="onBirthCityBlur"
              @selectItem="selectBirthCity"
          >
            <template #list-item-text="{ item }">
              {{ item.name }} ({{ item.postalCode }})
            </template>
            <template #list-footer>
              <div v-if="showBirthCitySelectionHint && birthCityList.length">
                ⚠️ Voulez-vous dire : <strong>{{ birthCityList[0].name }} ({{ birthCityList[0].postalCode }})</strong> ? Cliquez sur la proposition.
              </div>
            </template>
          </vue3-simple-typeahead>
          <Field v-model="birthplace" class="form-control" hidden name="birthplace" type="text"/>
          <ErrorMessage class="error-feedback" name="birthplace"/>
        </div>
        <div v-else class="form-group">
          <Field v-model="birthplace" class="form-control" name="birthplace" placeholder="Lieu de naissance*" type="text"/>
          <ErrorMessage class="error-feedback" name="birthplace"/>
        </div>
        <Field id="birthCityFieldId" v-model="birthCitySelection" class="form-control" hidden name="birthCityFieldId" type="text"/>
        <Field v-model="birth_department" class="form-control" hidden name="birth_department" id="birth_department" type="text"/>
        <ErrorMessage class="error-feedback" name="birth_department"/>
        <div class="header-group">
          <h1><img src="@/assets/img/underline.png"> COORDONNEES</h1>
        </div>
        <div class="form-group">
          <Field v-model="email" class="form-control" name="email" placeholder="Email*" type="email"/>
          <ErrorMessage class="error-feedback" name="email"/>
        </div>
        <div class="form-group">
          <Field v-model="phone_number" class="form-control" name="phone_number" placeholder="Téléphone*" type="text"/>
          <ErrorMessage class="error-feedback" name="phone_number"/>
        </div>
        <div class="form-group">
          <Field v-model="address" class="form-control" name="address" placeholder="Adresse*" type="text"/>
          <ErrorMessage class="error-feedback" name="address"/>
        </div>
        <div v-if="ifCity" class="form-group register-city">
          <div>Votre ville actuelle : {{ city.name }} {{ city.postalCode }}</div>
          <div class="register-city-change" @click="changeCity">Changer</div>
        </div>
        <div v-if="bChangeCity" class="form-group">
          <vue3-simple-typeahead
              id="cityList"
              ref="cityList"
              v-model="search"
              :defaultItem="city"
              :itemProjection="cityItemProjection"
              :items="list"
              :minInputLength="3"
              name="cityList"
              placeholder="Ville*"
              @input="onInput"
              @onBlur="onBlur"
              @selectItem="selectItem"
          >
            <template #list-item-text="{ item }">
              {{ item.name }} ({{ item.postalCode }})
            </template>
            <template #list-footer>
              <div v-if="showCitySelectionHint && list.length">
                ⚠️ Voulez-vous dire : <strong>{{ list[0].name }} ({{ list[0].postalCode }})</strong> ? Cliquez sur la proposition.
              </div>
            </template>
          </vue3-simple-typeahead>
        </div>
        <!-- Pas de v-model ici : vee-validate ne détecte pas les changements sur hidden via v-model -->
        <!-- On pilote city_hidden exclusivement via setFieldValue -->
        <Field id="cityField" class="form-control" hidden name="city_hidden" type="text"/>
        <ErrorMessage class="error-feedback" name="city_hidden"/>
        <div class="header-group">
          <h1><img src="@/assets/img/underline.png"> MA VIDÉO DE PRÉSENTATION</h1>
        </div>
        <div class="form-group video-presentation-section">
          <div class="video-camera-btn" @click="openVideoModal">
            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M23 7l-7 5 7 5V7z"/>
              <rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
            </svg>
            <span>{{ videoUrlSaved ? 'Modifier ma vidéo' : 'Ajouter ma vidéo' }}</span>
          </div>
        </div>
        <div class="form-group">
          <button :disabled="isDisabled" class="btn btn-primary btn-block">
            <span v-show="loading" class="spinner-border spinner-border-sm"></span>
            Mettre à jour votre compte
          </button>
        </div>
      </div>
    </Form>
    <Teleport to="body">
      <div v-if="showVideoModal" class="video-modal-overlay" @click.self="closeVideoModal">
        <div class="video-modal-content">
          <button class="video-modal-close" @click="closeVideoModal">&times;</button>
          <h3 class="video-modal-title">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M23 7l-7 5 7 5V7z"/>
              <rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
            </svg>
            Ma vidéo de présentation
          </h3>
          <p class="video-modal-description">
            Aidez les recruteurs grâce à une courte vidéo expliquant&nbsp;: votre parcours, vos motivations et votre intérêt pour le métier d'ASV.<br>
            Tutoriel : <a href="https://support.google.com/youtube/answer/57407?hl=fr&co=GENIE.Platform%3DAndroid" target="_blank" rel="noopener noreferrer">Mettre en ligne des vidéos YouTube - Android - Aide YouTube</a>
          </p>
          <div class="form-group">
            <div class="video-url-input-wrapper">
              <input
                  v-model="videoUrl"
                  type="text"
                  class="form-control"
                  placeholder="Collez un lien YouTube (ex: https://www.youtube.com/watch?v=...)"
                  @input="handleVideoInput"
              />
              <button v-if="videoUrl" class="video-url-clear" type="button" @click="clearVideoUrl">&times;</button>
            </div>
            <div v-if="videoUrlError" class="error-feedback">{{ videoUrlError }}</div>
          </div>
          <div v-if="videoEmbedUrl" class="video-iframe-wrapper">
            <iframe
                :src="videoEmbedUrl"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
            ></iframe>
          </div>
          <div v-if="videoEmbedUrl" class="video-consent">
            <label class="video-consent-label">
              <input v-model="videoDiffusionAccept" type="checkbox"/>
              J'autorise la diffusion de cette vidéo aux employeurs vétérinaires
            </label>
          </div>
          <div class="video-modal-actions">
            <button class="btn btn-cancel" type="button" @click="closeVideoModal">Annuler</button>
            <button
                :disabled="confirmVideoDisabled"
                class="btn btn-primary"
                type="button"
                @click="confirmVideo"
            >Confirmer</button>
          </div>
        </div>
      </div>
    </Teleport>
    <div
        v-if="message"
        :class="successful ? 'alert-success' : 'alert-danger'"
        class="alert"
    >
      {{ message }}
    </div>
  </div>
</template>

<script>
import {ErrorMessage, Field, Form} from "vee-validate";
import * as yup from "yup";
import Toast from "@/_helpers/AlerteHelper";
import UserService from "@/services/user.service";
import DashboardHeader from "@/components/Dashboard/Header.vue";
import CityApi from "@/api/CityApi";
import NationalityApi from "@/api/NationalityApi";
import {createDebouncedSearch} from "@/utils/debouncedSearch";

export default {
  name: "Profil",
  components: {
    DashboardHeader,
    Form,
    Field,
    ErrorMessage
  },
  data() {
    const schema = yup.object().shape({
      civility: yup
          .string()
          .required("La civilité est nécessaire"),
      nationality: yup
          .string()
          .required("La nationalité est nécessaire"),
      lastname: yup
          .string()
          .required("Le nom est nécessaire")
          .matches(/^[A-Za-zÀ-ÿ0-9 ’'-.]*$/, "Le nom n'est pas valide")
          .min(2, "Doit comporter au moins 2 caractères"),
      marriedname: yup
          .string()
          .nullable()
          .matches(/^[A-Za-zÀ-ÿ0-9 ’'-.]*$/, "Le nom marital n'est pas valide")
          .test(
              "different-from-lastname",
              "Le nom marital doit être différent du nom de naissance",
              function (value) {
                const { lastname } = this.parent;
                if (!value) return true;
                return value !== lastname;
              }
          ),
      firstname: yup
          .string()
          .required("Le prénom est nécessaire")
          .matches(/^[A-Za-zÀ-ÿ0-9 ’'-.]*$/, "Le prénom n'est pas valide")
          .min(2, "Doit comporter au moins 2 caractères"),
      birthday: yup
          .date()
          .min('01/01/1900', "La date de naissance est invalide")
          .max('01/01/2100', "La date de naissance est invalide")
          .test(
              "",
              "Vous devez avoir minimum 18ans",
              (val) => {
                if (!val) return false;
                const today = new Date();
                const birthDate = new Date(val);
                let age = today.getFullYear() - birthDate.getFullYear();
                const m = today.getMonth() - birthDate.getMonth();
                if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                  age--;
                }
                return age >= 18;
              }
          )
          .typeError('La date de naissance est invalide')
          .required("La date de naissance est nécessaire"),
      address: yup
          .string()
          .matches(/^[A-Za-zÀ-ÿ0-9 @"’'-.]*$/, "L'adresse n'est pas valide")
          .required("L'adresse est nécessaire")
          .min(6, "Doit comporter au moins 6 caractères")
          .max(80, "Doit comporter au maximum 70 caractères"),
      phone_number: yup
          .string()
          .matches(/^((\+)33|0|0033)[1-9](\d{2}){4}$/, "Le numéro de téléphone n'est pas valide")
          .required("Le numéro de téléphone est nécessaire"),
      email: yup
          .string()
          .matches(/^\w+([.+-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/, "L'email n'est pas valide")
          .required("L'email est nécessaire"),
      city_hidden: yup
          .string()
          .required("La ville est nécessaire"),
    });

    return {
      successful: false,
      loading: false,
      message: "",
      schema,
      list: [],
      search: "",
      birthCitySearch: "",
      birthCityList: [],
      birthCitySelection: null,
      bornAbroad: false,
      isBirthplaceSelected: false,
      showBirthCitySelectionHint: false,
      email: "",
      initialEmail: "",
      nationality: "",
      nationalities: [],
      civility: "",
      lastname: "",
      firstname: "",
      marriedname: "",
      birthday: "",
      birthplace: "",
      birth_department: "",
      address: "",
      phone_number: "",
      city: {
        id: '',
        postalCode: "",
        name: ""
      },
      showCitySelectionHint: false,
      birthplaceCity: {
        id: 0,
        postalCode: "",
        name: ""
      },
      bChangeCity: false,
      profilePictureUrl: null,
      title: "Espace candidat",
      subtitle: "Votre profil",
      croppedImageFile: null,
      showVideoModal: false,
      videoUrl: '',
      videoUrlSaved: '',
      videoEmbedUrl: null,
      videoUrlError: '',
      videoDiffusionAccept: false
    };
  },
  created() {
    // Flags non-réactifs pour bloquer le @input parasite émis par vue3-simple-typeahead
    // via son clearInput() interne juste après chaque sélection
    this._citySelecting = false;
    this._birthCitySelecting = false;
    this._videoDiffusionSnapshot = false;
    this._citySearch = createDebouncedSearch((term) => CityApi.getCities(term), {
      onResults: (results) => this.list = results,
      onError: (error) => console.error('Error loading cities:', error)
    });
    this._birthCitySearch = createDebouncedSearch((term) => CityApi.getCities(term), {
      onResults: (results) => this.birthCityList = results,
      onError: (error) => console.error('Error loading birth cities:', error)
    });
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    isDisabled() {
      return this.loading;
    },
    ifCity() {
      return !!this.city.id;
    },
    bornInFrance() {
      return !this.bornAbroad;
    },
    confirmVideoDisabled() {
      return !!this.videoUrl.trim() && !this.videoDiffusionAccept;
    }
  },
  watch: {
    bornAbroad(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.showBirthCitySelectionHint = false;
        this.birth_department = '99';
        this.birthCitySelection = null;
        this.birthplaceCity = { id: 0, postalCode: "", name: "" };
        this.birthCitySearch = "";
        this._birthCitySearch.cancel();
        this.birthCityList = [];
        this.isBirthplaceSelected = false;
        this._birthCitySelecting = false;
      }
    }
  },
  mounted() {
    ['birthplaceList', 'cityList'].forEach(id => {
      const el = document.getElementById(id);
      if (el) {
        el.autocomplete = 'off';
        el.autocorrect = 'off';
        el.autocapitalize = 'off';
        el.spellcheck = 'off';
      }
    });

    NationalityApi.getNationalities().then((nationalities) => {
      this.nationalities = nationalities;
    }).catch((error) => {
      console.error('Error loading nationalities:', error);
    });

    UserService.getCandidacyByUser().then((response) => {
      this.candidacy = response.data;
      this.email = this.candidacy.email;
      this.initialEmail = this.email ? (' ' + this.email.toLowerCase()).slice(1) : '';
      this.civility = this.candidacy.civility;
      this.lastname = this.candidacy.last_name;
      this.firstname = this.candidacy.first_name;
      this.marriedname = this.candidacy.married_name;
      this.birthday = this.candidacy.birthday
          ? new Date(this.candidacy.birthday.date.slice(0, 10)).toISOString().slice(0, 10)
          : null;
      this.nationality = this.candidacy.nationality ? String(this.candidacy.nationality) : "";
      this.birth_department =
          this.candidacy.birth_department?.length === 1
              ? '0' + this.candidacy.birth_department
              : this.candidacy.birth_department;
      this.birthplace = this.candidacy.birth_place;
      this.address = this.candidacy.address;
      this.phone_number = this.candidacy.phone_number;
      this.videoUrlSaved = this.candidacy.youtube_link || '';
      this.videoUrl = this.videoUrlSaved;
      this.videoDiffusionAccept = this.candidacy.youtube_diffusion_accept ?? false;
      if (this.videoUrlSaved) {
        const id = this.extractYoutubeId(this.videoUrlSaved);
        this.videoEmbedUrl = id ? `https://www.youtube.com/embed/${id}` : null;
      }

      if (this.candidacy.city_id) {
        CityApi.getCity(this.candidacy.city_id).then((res) => {
          this.city = {
            id: res.data.id,
            postalCode: res.data.postalCode,
            name: res.data.name,
          };
          this.search = res.data.name + ' (' + res.data.postalCode + ')';
          // Injecter la valeur dans vee-validate via setFieldValue
          this.$nextTick(() => {
            this.$refs.profileForm?.setFieldValue('city_hidden', res.data.id);
          });
        }).catch((error) => {
          console.error('Error loading city:', error);
          this.bChangeCity = true;
        });
      } else {
        this.bChangeCity = true;
      }

      if (response.data.medias && Array.isArray(response.data.medias)) {
        Array.from(response.data.medias).forEach(file => {
          if (file.typeOfMedia === 'PHOTOIDENTITY') {
            this.profilePictureUrl = file.fileLink;
          }
        });
      }

      if (this.candidacy.birth_place) {
        CityApi.getCities(this.candidacy.birth_place).then((res) => {
          const cities = res && Array.isArray(res) ? res : [];
          const matchedCity = cities.find(
              (city) => city.name?.toLowerCase() === this.candidacy.birth_place?.toLowerCase()
          );
          if (matchedCity) {
            this.bornAbroad = false;
            this.birthplaceCity = {
              id: matchedCity.id,
              postalCode: matchedCity.postalCode,
              name: matchedCity.name,
            };
            this.birthplace = matchedCity.name;
            this.birth_department = matchedCity.postalCode && (matchedCity.postalCode.startsWith('97') || matchedCity.postalCode.startsWith('98'))
                ? matchedCity.postalCode.slice(0, 3)
                : matchedCity.postalCode ? matchedCity.postalCode.slice(0, 2) : '';
            this.birthCitySelection = matchedCity.id;
            this.isBirthplaceSelected = true;
            this.birthCitySearch = matchedCity.name + ' (' + matchedCity.postalCode + ')';
            this.$nextTick(() => {
              if (this.$refs.birthplaceList?.selectItem) {
                this.$refs.birthplaceList.selectItem(matchedCity);
              }
            });
          } else {
            this.bornAbroad = true;
            this.birthplace = this.candidacy.birth_place;
            this.birth_department = this.candidacy.birth_department || '99';
            this.isBirthplaceSelected = false;
          }
        }).catch((error) => {
          console.error('Error loading birth place cities:', error);
          this.bornAbroad = true;
          this.birthplace = this.candidacy.birth_place;
          this.birth_department = this.candidacy.birth_department || '99';
          this.isBirthplaceSelected = false;
        });
      }
    }).catch((error) => {
      console.error('Error loading candidacy:', error);
    });
  },
  methods: {
    changeCity() {
      this.bChangeCity = !this.bChangeCity;
    },

    // --- Ville de résidence ---

    cityItemProjection(item) {
      if (!item.name) return '';

      const label = item.name + ' (' + item.postalCode + ')';
      const input = this.$refs.cityList?.input || '';

      return label.toLowerCase().includes(input.toLowerCase())
          ? label
          : label.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    },
    selectItem(item) {
      // Flag levé avant que vue3-simple-typeahead déclenche clearInput() + @input
      this._citySelecting = true;
      this.showCitySelectionHint = false;
      this._citySearch.cancel();
      this.list = [];
      this.city = { id: item.id, postalCode: item.postalCode, name: item.name };
      // setFieldValue : seul moyen fiable de notifier vee-validate sur un champ hidden
      this.$refs.profileForm.setFieldValue('city_hidden', item.id);
      // $nextTick : on réécrit search après que clearInput() ait effacé le v-model
      this.$nextTick(() => {
        this.search = item.name + ' (' + item.postalCode + ')';
        this.$refs.cityList.input = this.search;
        this.$refs.cityList.isInputFocused = false;
        this._citySelecting = false;
      });
    },
    onInput(event) {
      // Ignorer le @input parasite déclenché par clearInput() juste après une sélection
      if (this._citySelecting) return;
      this.showCitySelectionHint = false;
      // Saisie libre → invalider city_hidden dans vee-validate
      this.city = { id: '', postalCode: '', name: '' };
      this.$refs.profileForm.setFieldValue('city_hidden', '');
      this._citySearch(event.target.value);
    },
    onBlur() {
      if (!this.city.id) {
        this._citySearch.cancel();
        this.search = '';
        this.city = { id: '', postalCode: '', name: '' };
        this.$refs.profileForm.setFieldValue('city_hidden', '');
        if (this.list.length) {
          this.showCitySelectionHint = true;
          this.$nextTick(() => {
            this.$refs.cityList.isInputFocused = true;
          });
        }
      }
    },
    handleInvalidSubmit({errors}) {
      if (errors.city_hidden && this.list.length) {
        this.showCitySelectionHint = true;
        this.$nextTick(() => {
          this.$refs.cityList.isInputFocused = true;
        });
      }
    },

    // --- Ville de naissance ---

    birthCityItemProjection(item) {
      if (!item.name) return '';

      const label = item.name + ' (' + item.postalCode + ')';
      const input = this.$refs.birthplaceList?.input || '';

      return label.toLowerCase().includes(input.toLowerCase())
          ? label
          : label.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    },
    selectBirthCity(item) {
      this._birthCitySelecting = true;
      this._birthCitySearch.cancel();
      this.birthCityList = [];
      this.showBirthCitySelectionHint = false;
      this.birthplace = item.name;
      const postalCode = item.postalCode
          ? item.postalCode.toString().slice(0, item.postalCode.startsWith('97') || item.postalCode.startsWith('98') ? 3 : 2)
          : '';
      this.birth_department = postalCode;
      this.birthCitySelection = item.id;
      this.birthplaceCity = { id: item.id, postalCode: item.postalCode, name: item.name };
      this.isBirthplaceSelected = true;
      this.$nextTick(() => {
        this.birthCitySearch = item.name + ' (' + item.postalCode + ')';
        this.$refs.birthplaceList.input = this.birthCitySearch;
        this.$refs.birthplaceList.isInputFocused = false;
        this._birthCitySelecting = false;
      });
    },
    onBirthCityInput(event) {
      if (this._birthCitySelecting) return;
      this.showBirthCitySelectionHint = false;
      // Saisie libre → invalider la sélection
      this.isBirthplaceSelected = false;
      this.birthCitySelection = null;
      this.birthplace = '';
      this.birth_department = '';
      this._birthCitySearch(event.target.value);
    },
    onBirthCityBlur() {
      if (!this.bornAbroad && !this.isBirthplaceSelected) {
        this._birthCitySearch.cancel();
        this.birthCitySearch = '';
        this.birthplace = '';
        this.birth_department = '';
        this.birthCitySelection = null;
        this.birthplaceCity = { id: 0, postalCode: '', name: '' };
        if (!this.bornAbroad && !this.isBirthplaceSelected && this.birthCityList.length) {
          this.showBirthCitySelectionHint = true;
          this.$nextTick(() => {
            this.$refs.birthplaceList.isInputFocused = true;
          });
        }
      }
    },

    handlePhotoUpdate({file, url}) {
      this.croppedImageFile = file;
      this.profilePictureUrl = url;
    },
    handleUpdate(user) {
      this.message = "";
      this.successful = false;
      this.loading = true;
      const cityField = document.getElementById('cityField');
      const birthDepartmentField = document.getElementById('birth_department');
      const birthCityField = document.getElementById('birthCityFieldId');
      user.city = cityField?.value;
      user.birth_department = birthDepartmentField?.value;
      user.birth_city_id = birthCityField?.value;
      user.candidacy_id = this.candidacy.id ?? null;
      user.youtubeLink = this.videoUrlSaved;
      user.youtubeDiffusionAccept = this.videoDiffusionAccept;

      if (this.croppedImageFile) {
        const formDataPhoto = new FormData();
        formDataPhoto.append('file', this.croppedImageFile, this.croppedImageFile.name);
        user.photoMedia = formDataPhoto;
      }

      this.update(user);
    },
    openVideoModal() {
      this._videoDiffusionSnapshot = this.videoDiffusionAccept;
      this.videoUrl = this.videoUrlSaved;
      this.videoUrlError = '';
      const id = this.extractYoutubeId(this.videoUrlSaved);
      this.videoEmbedUrl = id ? `https://www.youtube.com/embed/${id}` : null;
      this.showVideoModal = true;
    },
    closeVideoModal() {
      this.videoDiffusionAccept = this._videoDiffusionSnapshot;
      this.videoUrl = this.videoUrlSaved;
      this.videoEmbedUrl = this.extractYoutubeId(this.videoUrlSaved)
          ? `https://www.youtube.com/embed/${this.extractYoutubeId(this.videoUrlSaved)}`
          : null;
      this.showVideoModal = false;
    },
    confirmVideo() {
      this.videoUrlSaved = this.videoUrl.trim();
      if (!this.videoUrlSaved) this.videoDiffusionAccept = false;
      this.showVideoModal = false;
    },
    clearVideoUrl() {
      this.videoUrl = '';
      this.videoEmbedUrl = null;
      this.videoUrlError = '';
    },
    handleVideoInput() {
      this.videoUrlError = '';
      this.videoEmbedUrl = null;
      const url = this.videoUrl.trim();
      if (!url) return;
      const id = this.extractYoutubeId(url);
      if (!id) {
        this.videoUrlError = 'Veuillez saisir un lien YouTube valide';
        return;
      }
      this.videoEmbedUrl = `https://www.youtube.com/embed/${id}`;
    },
    extractYoutubeId(url) {
      if (!url) return null;
      const match = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
      return match ? match[1] : null;
    },
    update(user) {
      let _ = this;
      let submitUpdateProfile = function () {
        UserService.updateProfile(user).then(
            (response) => {
              _.message = response.data.message;
              Toast('success', response.data.message, 'top-end', 3000);
              _.successful = true;
              setTimeout(function () {
                _.$router.push({name: 'dashboard'});
              }, 2000);
            },
            (error) => {
              _.message =
                  (error.response && error.response.data && error.response.data.message) ||
                  error.message ||
                  error.toString();
              Toast('error', _.message, 'top-end', 3000);
              _.successful = false;
              _.loading = false;
            }
        );
      };

      if (this.initialEmail !== user.email?.toLowerCase()) {
        UserService.updateEmailRequest(this.email).then(
            (response) => {
              this.message = response.data.message;
              Toast('success', response.data.message, 'top-end', 8000);
              this.successful = true;
              setTimeout(function () {
                submitUpdateProfile();
              }, 8000);
            },
            (error) => {
              this.message =
                  (error.response && error.response.data && error.response.data.message) ||
                  error.message ||
                  error.toString();
              Toast('error', this.message, 'top-end', 3000);
              this.successful = false;
              this.loading = false;
            }
        );
      } else {
        submitUpdateProfile();
      }
    }
  },
  beforeUnmount() {
    this._citySearch?.cancel();
    this._birthCitySearch?.cancel();
  }
};
</script>

<style scoped>
.video-presentation-section {
  display: flex;
  align-items: center;
}

.video-camera-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 10px 16px;
  border: 2px dashed #ccc;
  border-radius: 8px;
  color: #555;
  transition: border-color 0.2s, color 0.2s;
}

.video-camera-btn:hover {
  border-color: #007bff;
  color: #007bff;
}
</style>

<style>
.video-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.video-modal-content {
  background: #fff;
  border-radius: 12px;
  padding: 28px;
  width: 90%;
  max-width: 620px;
  position: relative;
}

.video-modal-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  font-size: 1.15rem;
  font-weight: 700;
  color: #2c3e50;
  letter-spacing: 0.01em;
  padding-bottom: 14px;
  border-bottom: 1px solid #f0f0f0;
}

.video-modal-title svg {
  color: #007bff;
  flex-shrink: 0;
}

.video-modal-description {
  font-size: 0.9rem;
  color: #555;
  margin-bottom: 16px;
  line-height: 1.55;
}

.video-modal-description a {
  font-size: 0.8rem;
  color: #999;
  text-decoration: none;
}

.video-url-input-wrapper {
  position: relative;
}

.video-url-input-wrapper .form-control {
  padding-right: 36px;
}

.video-url-clear {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 1.2rem;
  line-height: 1;
  color: #aaa;
  cursor: pointer;
  padding: 0;
  transition: color 0.15s ease;
}

.video-url-clear:hover {
  color: #555;
}

.btn-cancel {
  background: #fff;
  border: 1.5px solid #dee2e6;
  color: #6c757d;
  border-radius: 6px;
  padding: 8px 20px;
  font-size: 0.9rem;
  font-weight: 500;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;
  cursor: pointer;
}

.btn-cancel:hover {
  border-color: #adb5bd;
  background: #f8f9fa;
  color: #495057;
}

.video-modal-close {
  position: absolute;
  top: 12px;
  right: 16px;
  background: none;
  border: none;
  font-size: 1.6rem;
  line-height: 1;
  cursor: pointer;
  color: #888;
}

.video-modal-close:hover {
  color: #333;
}

.video-iframe-wrapper {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  border-radius: 8px;
  margin-top: 16px;
}

.video-iframe-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 8px;
}

.video-consent {
  margin-top: 14px;
}

.video-consent-label {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 0.9rem;
  color: #333;
  cursor: pointer;
}

.video-consent-label input[type="checkbox"] {
  margin-top: 3px;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.video-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}
</style>
